/** Practical format check — not overly strict on domain length. */
const EMAIL_FORMAT = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/** QA / disposable domains that should not be accepted (e.g. preethi@abc.com). */
const BLOCKED_EMAIL_DOMAINS = new Set([
  'abc.com',
  'test.com',
  'example.com',
  'example.net',
  'example.org',
  'invalid.com',
  'fake.com',
]);

export const PLUS_ALIAS_EMAIL_MESSAGE = 'Email addresses with + are not allowed.';

function parseEmailParts(email) {
  const v = String(email || '')
    .trim()
    .toLowerCase();
  const at = v.lastIndexOf('@');
  if (at <= 0 || at === v.length - 1) return null;
  return { local: v.slice(0, at), domain: v.slice(at + 1), full: v };
}

export function hasPlusAliasInLocalPart(email) {
  const parts = parseEmailParts(email);
  return parts ? parts.local.includes('+') : false;
}

/** Normalize for storage/lookup: trim, lowercase, strip +tag from local part (any provider). */
export function canonicalizeEmail(email) {
  const parts = parseEmailParts(email);
  if (!parts)
    return String(email || '')
      .trim()
      .toLowerCase();

  let { local, domain } = parts;
  const plus = local.indexOf('+');
  if (plus >= 0) local = local.slice(0, plus);

  return `${local}@${domain}`;
}

export function getEmailValidationError(email) {
  const v = String(email || '').trim();
  if (!v) return null;
  if (hasPlusAliasInLocalPart(v)) return PLUS_ALIAS_EMAIL_MESSAGE;
  if (!isValidEmail(v)) return 'Please enter a valid email address';
  return null;
}

export function isValidEmail(email) {
  const v = String(email || '').trim();
  const lower = v.toLowerCase();
  if (!v || !EMAIL_FORMAT.test(v)) return false;
  if (/\.\./.test(v)) return false;
  if (hasPlusAliasInLocalPart(lower)) return false;

  const at = lower.lastIndexOf('@');
  if (at <= 0 || at === lower.length - 1) return false;

  const domain = lower.slice(at + 1);
  if (BLOCKED_EMAIL_DOMAINS.has(domain)) return false;

  const labels = domain.split('.');
  if (labels.length < 2) return false;
  if (labels.some((label) => !label || label.length > 63)) return false;
  if (labels[labels.length - 1].length < 2) return false;

  return true;
}
